import { BREAKPOINT_MOBILE, BREAKPOINT_TABLET } from "@/js/constants";

export const isMobile = () => !!window.matchMedia(`(max-width: ${BREAKPOINT_MOBILE}px)`).matches;

export const isTablet = () => !!window.matchMedia(`(max-width: ${BREAKPOINT_TABLET}px)`).matches;

export const isTabletOnly = () =>
    !!window.matchMedia(
        `(min-width: ${BREAKPOINT_MOBILE + 1}px) and (max-width: ${BREAKPOINT_TABLET}px)`
    ).matches;

export const isDesktop = () =>
    !!window.matchMedia(`(min-width: ${BREAKPOINT_TABLET + 1}px)`).matches;
